import { TFunction } from 'i18next';

export const getQuestions = (t: TFunction) => {
  return t('store.productPage.faqs', { returnObjects: true }) as Array<{
    question: string;
    answer: string;
  }>;
};
